import { createContext, useContext } from 'react';

// Whether this deployment can send a text right now (#782): the reading of
// `deployment/messaging` that data/useSmsGate.jsx keeps, handed to every
// control that would ask the server for one. domain/smsGate.js has the why.
//
// Here rather than beside its provider because the provider reaches Firebase:
// a component importing this file stays renderable in the `ui` jest project,
// which has no Firebase.
//
// The default is off: a tree with no provider above it cannot send a text it
// was never told it could.
export const SmsGateContext = createContext(false);

/** True only while the server says texts can be sent. */
export function useSmsAvailable() {
  return useContext(SmsGateContext) === true;
}
